import TenantPage from 'layouts/TenantPage';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import { supplierService } from '../api/SupplierService';
import SupplierForm from '../components/SupplierForm';
import {
  DEFAULT_CSV_FORMAT,
  DEFAULT_ORDER_SEND_FORMAT,
  DEFAULT_RECEPTION_FORMAT
} from '../constants';
import { ISupplier } from '../types';

const initSupplier: ISupplier = {
  id: 0,
  code: '',
  description: '',
  company_name: '',
  email: '',
  order_send_format: DEFAULT_ORDER_SEND_FORMAT,
  reception_format: DEFAULT_RECEPTION_FORMAT,
  csv_format: DEFAULT_CSV_FORMAT,
  csv_mapping: {}
};
export const AddSupplier = () => {
  const translationPrefix = 'pages.supplier.new';
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const createSupplier = async (values) => {
    dispatch(loadingActions.startLoading());
    supplierService.add(values).then((res) => {
      enqueueSnackbar('Fornitore aggiunto con successo');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <SupplierForm supplier={initSupplier} onSubmit={createSupplier} />
    </TenantPage>
  );
};

export default AddSupplier;
